'use strict';
import moment from 'moment'
export function routeConfig($urlRouterProvider, $locationProvider, $mdIconProvider, $mdThemingProvider,
  $mdDateLocaleProvider, $translateProvider, $mdAriaProvider) {
  'ngInject';

  $mdDateLocaleProvider.formatDate = function(date) {
    return moment(date).format('DD-MM-YYYY');
  };

  $mdDateLocaleProvider.parseDate = function(dateString) {
    var m = moment(dateString, 'DD-MM-YYYY', true);
    return m.isValid() ? m.toDate() : new Date(NaN);
  };

  $mdAriaProvider.disableWarnings();

  $urlRouterProvider.otherwise('/');

  $locationProvider.html5Mode(true);

  $mdIconProvider
    .defaultIconSet("./assets/svg/avatars.svg", 128)
    .icon("menu", "./assets/svg/menu.svg", 24)
    .icon("share", "./assets/svg/share.svg", 24)
    .icon("google_plus", "./assets/svg/google_plus.svg", 24)
    .icon("hangouts", "./assets/svg/hangouts.svg", 24)
    .icon("twitter", "./assets/svg/twitter.svg", 24)
    .icon("phone", "./assets/svg/phone.svg", 24);

  $mdThemingProvider.theme('default')
    .primaryPalette('teal')
    .accentPalette('blue-grey', {
      "hue-1": '500'
    });

  $mdThemingProvider.theme('offers')
    .primaryPalette('teal')
    .accentPalette('cyan');

  $mdThemingProvider.theme('clients')
    .primaryPalette('blue')
    .accentPalette('teal');

  $mdThemingProvider.theme('client')
    .primaryPalette('indigo').accentPalette('pink');

  // $mdDateLocaleProvider.parseDate = function(dateString) {
  //   var m = moment(dateString, 'DD-MM-YYYY', true);
  //   return m.isValid() ? m.toDate() : new Date(NaN);
  // };

  $translateProvider.useStaticFilesLoader({
    files: [
      {
        prefix: './assets/locale/',
        suffix: '/account.json'
      },
      {
        prefix: './assets/locale/',
        suffix: '/application.json'
      },
      {
        prefix: './assets/locale/',
        suffix: '/enum.json'
      }
    ]
  });

  $translateProvider.registerAvailableLanguageKeys(['pl_PL'], {
    'en': 'en_US',
    'EN': 'en_US',
    'gb': 'en_US',
    'GB': 'en_US',
    'en_us': 'en_US',
    'en_UK': 'en_US',
    'en_uk': 'en_US',
    'en_GB': 'en_US',
    'en_gb': 'en_US',
    'pl': 'pl_PL',
    'PL': 'pl_PL'
  });

  $translateProvider.usePostCompiling(true);
  $translateProvider.fallbackLanguage('pl_PL');
  $translateProvider.preferredLanguage('pl_PL');
}



// WEBPACK FOOTER //
// ./client/app/app.config.js